<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="姓名">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
 
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
			 
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" icon="el-icon-plus" @click="toSave()">添加</el-button>
			<el-button type="danger" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="cid" label="课程id"></el-table-column>
				<el-table-column prop="olClassname" label="线上班级"></el-table-column>
				<el-table-column prop="starttime" label="开始时间"></el-table-column>
				<el-table-column prop="endtime" label="结课时间"></el-table-column>
				<el-table-column prop="historyteacher" label="带班老师">
					<div class="block">
						<el-cascader :options="options" :props="{ checkStrictly: true }" clearable></el-cascader>
					</div>
				</el-table-column>
				<el-table-column prop="status" label="状态"></el-table-column>
				<el-table-column label="操作" fixed="right" width="400px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button v-has-permission-code-and="'00850005'" size="mini" icon="el-icon-search"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button v-has-permission-code-and="'008500050010'" size="mini" icon="el-icon-edit"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button v-has-permission-code-and="'008500050010'" size="mini" icon="el-icon-delete" type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/online/clazzonline/clazzonline.js';
export default {
	name: 'tStuClazzOnline',
	components: {
		edit
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			options: [],
			page: new this.$constant.pageObj(),
		};
	},
	methods: {

		//获取导师选择器
		mentor() {
			this.listLoading = false;
			api.list(params, response => {
				const { teachers, students } = response.data;

				this.options = [
					{
						label: 'Teachers',
						options: teachers.map(teacher => ({
							value: teacher.id,
							label: teacher.name
						}))
					},
					{
						label: 'Students',
						options: students.map(student => ({
							value: student.id,
							label: student.name
						}))
					}
				];

				this.listLoading = false;
			}, error => {
				console.error('Error fetching data:', error);
				this.listLoading = false;
			});
		},
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		// this.mentor();
		this.list();
	},
	created(){
		api.mentor(null,res=>{
			this.options = res.data;
		console.log("options"+options)
		});
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
